import React from 'react'
import clsx from 'clsx'
import { useMediaQuery, useTheme } from '@mui/material'
import { useGlobalStyles } from '~shared/styles/globalStyles'

interface Props {
  children: React.ReactNode
  useMobileVerticalPadding?: boolean
  useMobileHorizontalPadding?: boolean
  className?: string
}

const ScreenContainerMain: React.FC<Props> = (props) => {
  const gs = useGlobalStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return <div
    className={clsx(
      gs.screenContainer,
      isMobile && gs.screenContainerMobile,
      props.useMobileVerticalPadding && gs.screenContainerMobileVerticalPadding,
      props.useMobileHorizontalPadding && gs.screenContainerMobileHorizontalPadding,
      props.className && props.className,
    )}
  >
    {props.children}
  </div>
}

export default ScreenContainerMain
